import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import { useRegex } from "../../../../hooks/useRegex";
import { HomepageFormContainer } from "./styled/homepage";

import { IoIosSettings } from "react-icons/io";
import { HiDesktopComputer } from "react-icons/hi";
import { TiPlus } from "react-icons/ti";
import { IoDocuments } from "react-icons/io5";

export default function HomepageForm({ portfolio }) {
  const navigate = useNavigate();

  const { BussinessFormat } = useRegex();
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });

  const setting = useSelector((state) => state?.user?.setting);
  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  const [companys, setCompanys] = useState([]);

  useEffect(() => {
    checkedDomain();
  }, []);

  const checkedDomain = async () => {
    const url = "/api/domainSettingLoad";

    const promises = company.map((item) => {
      const body = { cmpnyNo: item.cmpnyNo, delYn: "N" };
      return axios.post(url, body);
    });

    try {
      const res = await Promise.all(promises);

      const updatedData = company.map((item) => {
        const response = res.find((r) => r.data.cmpnyNo === item.cmpnyNo);
        return {
          ...item,
          domain: response?.data?.domain,
        };
      });

      updatedData.sort((a, b) => {
        const aHasDomain = a.domain;
        const bHasDomain = b.domain;

        if (aHasDomain && !bHasDomain) return -1;
        if (!aHasDomain && bHasDomain) return 1;
        return 0;
      });

      setCompanys(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const openNewTab = (item) => {
    window.open(`https://1472.ai/shop/${item}`);
  };

  const navSettingPage = (item) => {
    sessionStorage.setItem("homepageCompany", JSON.stringify({ ...item }));
    if (portfolio) {
      navigate("/mypage/registerPhotoUpload", {
        state: { images: portfolio },
      });
    } else {
      sessionStorage.setItem("homepageCompany", JSON.stringify({ ...item }));
      navigate("/mypage/homepageSetting");
    }
  };

  return (
    <HomepageFormContainer className={setting?.mode}>
      <div className="viewer">
        <table>
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>사업자번호</th>
              <th>홈페이지 관리</th>
            </tr>
          </thead>
          <tbody id="place_tbody">
            {companys.map((item) => (
              <tr>
                <td>
                  <span>{item.cmpnyNm}</span>
                  <span>{`(${item.bizrno ? BussinessFormat(item.bizrno) : ""})`}</span>
                </td>
                {item.domain ? (
                  <td>
                    <div>
                      <Link onClick={() => openNewTab(item.domain)}>
                        <HiDesktopComputer /> 홈페이지 바로가기
                      </Link>
                      {/* <button onClick={() => navSettingPage(item)}>
                        {portfolio ? <IoDocuments /> : <IoIosSettings />}
                        {portfolio ? "등록" : "관리"}
                      </button> */}
                    </div>
                  </td>
                ) : (
                  <td>
                    <div>
                      <button
                        onClick={() =>
                          navigate("/mypage/makeDomain", { state: { cmpnyNo: item.cmpnyNo } })
                        }>
                        <TiPlus />
                        생성
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </HomepageFormContainer>
  );
}
